import { ApiConfig, Variables } from '@common/types/api'
import { normalizeProduct } from '@framework/utils'
import { Product } from '@common/types/product'
import { Product as ShopifyProduct } from '../schema'
import getRecomendedProductsQuery from '@framework/utils/queries/get-recommended-products'
import { Metafields } from '@framework/types/metafields'

type ReturnType = {
  productRecommendations: ShopifyProduct[]
}

const getRecommendedProducts = async (options: {
  config: ApiConfig
  variables: Variables
}): Promise<Product[]> => {
  const { config, variables } = options

  const { data } = await config.fetch<ReturnType>({
    query: getRecomendedProductsQuery,
    variables,
  })

  const products =
    data.productRecommendations.map((product) =>
      normalizeProduct(product as ShopifyProduct & Metafields)
    ) ?? []

  return products
}

export default getRecommendedProducts
